module.exports = __webpack_public_path__ + "static/media/home_banner_1.b2188a5b.jpg";